import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { ModalEl } from "common/components/modal";
import { EventCarouselEl } from "./event-carousel";
export function template() {
  const Profile = ({ idx, src }) => /* @__PURE__ */ jsx("div", {
    sel: ".profile",
    class: {
      [`profile-fg-${idx}`]: true
    },
    key: `profile${idx}`
  }, /* @__PURE__ */ jsx("div", {
    sel: ".profile-img"
  }, /* @__PURE__ */ jsx("img", {
    attrs: {
      src,
      alt: `user`,
      draggable: `false`,
      width: `100%`
    }
  })));
  const SkipButton = () => /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".skip-button",
    attrs: {
      theme: ButtonTheme.Tertiary,
      href: this.helpers.appendMpSource(`intro-skip`)
    }
  }, "Skip");
  const NextButton = () => /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".next-button",
    attrs: { theme: ButtonTheme.Primary },
    on: { click: this.helpers.nextStep }
  }, "Next \u2192");
  const StepButton = ({ index, step: step2 }) => /* @__PURE__ */ jsx("div", {
    sel: ".step-button",
    class: { active: step2.active, visited: step2.visited, [step2.name]: true },
    on: { click: () => this.helpers.handleStepClick(index) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".step-button-content"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: step2.icon }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".step-button-label"
  }, step2.text)), /* @__PURE__ */ jsx("div", {
    sel: ".step-button-indicator"
  }, step2.visited ? /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `circle-checkmark` }
  }) : /* @__PURE__ */ jsx("div", {
    sel: ".step-button-index"
  }, index + 1)));
  const OverviewCopy = () => /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".title"
  }, "Hi", this.attr(`first-name`) && ` ${this.attr(`first-name`)}`, ","), /* @__PURE__ */ jsx("h1", {
    sel: ".title"
  }, "welcome to Mixpanel"), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Mixpanel is a tool that helps you understand how your users interact with your app."), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Let's spend a few minutes to walk through a couple concepts to get you started."), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".next-button",
    attrs: { theme: ButtonTheme.Primary },
    on: { click: this.helpers.nextStep }
  }, "Get Started"), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const OverviewImages = () => /* @__PURE__ */ jsx("div", {
    sel: ".images"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".image-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".shapes-fg-1"
  }, /* @__PURE__ */ jsx("img", {
    attrs: {
      src: require(`./images/onboarding-shapes.svg`),
      alt: `shapes`,
      width: 400,
      height: `auto`,
      draggable: `false`
    },
    key: "shapes1"
  }))));
  const UsersCopy = () => /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".title"
  }, "Every individual is a unique user"), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Imagine for a moment, you own a caf\xE9."), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Every customer who visits your cafe is unique. Details like their name, age, favorite coffee, and most recently purchased pastry are what make every customer unique."), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "In Mixpanel, these customers are called", /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, ` `, "users"), ", and their details are called", /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, ` `, "profile properties"), ". We keep track of this information to help you better understand your audience."), /* @__PURE__ */ jsx(NextButton, null), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const UsersImages = () => /* @__PURE__ */ jsx("div", {
    sel: ".images"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".image-container"
  }, /* @__PURE__ */ jsx(Profile, {
    idx: 1,
    src: require(`./images/profiles/kathy.svg`)
  }), /* @__PURE__ */ jsx(Profile, {
    idx: 2,
    src: require(`./images/profiles/jill.svg`)
  }), /* @__PURE__ */ jsx(Profile, {
    idx: 3,
    src: require(`./images/profiles/brad.svg`)
  })));
  const EventsCopy = () => /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".title"
  }, "Any action can be tracked as an event"), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Every time a customer purchases a coffee at your caf\xE9, there are details that describe the purchase the moment it happens. Actions like purchasing a coffee can be tracked as an", /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, ` `, "event", ` `), "in Mixpanel. All details describing the event in the moment are called", /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, ` `, "event properties.")), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "User Action =", ` `, /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, "Event"), /* @__PURE__ */ jsx("br", null), "Details =", ` `, /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, "Event Properties")), /* @__PURE__ */ jsx(NextButton, null), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const EventsImages = () => /* @__PURE__ */ jsx("div", {
    sel: ".images"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".image-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".event-carousel-container"
  }, /* @__PURE__ */ jsx(EventCarouselEl, null))));
  const ProfilesCopy = () => /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".title"
  }, "Profiles bring everything together"), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "With profile properties keeping track of who a user is, and events keeping track of what a user does, Mixpanel consolidates this information into a", /* @__PURE__ */ jsx("b", {
    sel: ".strong"
  }, ` `, "profile", ` `), "for every user."), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Having all this customer information available allows you to uncover your caf\xE9's most popular pastry or the average amount spent by each customer."), /* @__PURE__ */ jsx(NextButton, null), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const CompleteCopy = () => /* @__PURE__ */ jsx("div", {
    sel: ".content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".title"
  }, "Great work \u{1F389}"), /* @__PURE__ */ jsx("p", {
    sel: ".text"
  }, "Now that you\u2019re familiar with Mixpanel building blocks, you\u2019re ready to get started."), /* @__PURE__ */ jsx("p", {
    sel: ".text.dashboards-notice"
  }, "Boards are the homebase for you to collaborate with your team."), this.attr(`is-full-page`) ? /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".next-button",
    attrs: { theme: ButtonTheme.Primary, href: this.helpers.appendMpSource(`intro-complete`) }
  }, this.attr(`cta-copy`)) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".next-button",
    attrs: { theme: ButtonTheme.Primary },
    on: { click: this.helpers.onCloseButtonClick }
  }, this.attr(`cta-copy`)), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".learn-more-button",
    attrs: {
      href: `https://mixpanel.com/project/2195193/app/dashboards#id=3679845`,
      theme: ButtonTheme.Tertiary,
      target: `_blank`
    }
  }, "View Demo"))));
  const CompleteImagesDashboard = () => /* @__PURE__ */ jsx("div", {
    sel: ".images"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".image-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".ellipse-bg.hide-overhang"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".dashboard-fg"
  }, /* @__PURE__ */ jsx("img", {
    attrs: {
      src: require(`./images/onboarding-dashboard.svg`),
      alt: `board`,
      draggable: `false`
    },
    key: "dashboard"
  })))));
  const ProfileBradGif = () => /* @__PURE__ */ jsx("div", {
    sel: ".images"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".image-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".ellipse-bg"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".profile-animated"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".profile-img"
  }, /* @__PURE__ */ jsx("img", {
    attrs: {
      src: require(`./images/profiles/brad-animated.gif`),
      alt: `brad`,
      draggable: `false`,
      width: 360
    }
  }))))));
  const { step } = this.state;
  const steps = this.helpers.getIntroSteps();
  const currentStep = steps[step];
  const buttonSteps = steps.slice(0, -1);
  const IntroContent = () => /* @__PURE__ */ jsx("div", {
    sel: ".intro-page"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".intro-container",
    class: { "is-full-page": this.attr(`is-full-page`) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".header"
  }, /* @__PURE__ */ jsx("a", {
    sel: ".logo",
    attrs: { href: `/` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".steps"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".steps-container"
  }, buttonSteps.map((step2, idx) => /* @__PURE__ */ jsx(StepButton, {
    index: idx,
    step: step2
  })))), currentStep.name === this.helpers.IntroStepName.Mixpanel ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(OverviewCopy, null), /* @__PURE__ */ jsx(OverviewImages, null)) : currentStep.name === this.helpers.IntroStepName.Users ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UsersCopy, null), /* @__PURE__ */ jsx(UsersImages, null)) : currentStep.name === this.helpers.IntroStepName.Events ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(EventsCopy, null), /* @__PURE__ */ jsx(EventsImages, null)) : currentStep.name === this.helpers.IntroStepName.Profiles ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ProfilesCopy, null), /* @__PURE__ */ jsx(ProfileBradGif, null)) : currentStep.name === this.helpers.IntroStepName.Complete ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(CompleteCopy, null), /* @__PURE__ */ jsx(CompleteImagesDashboard, null)) : null));
  return this.attr(`is-full-page`) ? /* @__PURE__ */ jsx(IntroContent, null) : /* @__PURE__ */ jsx(ModalEl, {
    attrs: {
      elref: `introModal`,
      closeable: true,
      open: true,
      "grow-to-content": true
    }
  }, /* @__PURE__ */ jsx(IntroContent, null));
}
